<template>
  <v-footer dark padless absolute>
    <v-card class="flex" flat tile :color="color">
      <v-card-text class="py-2 white--text text-center" data-qa-date>
        {{ new Date().getFullYear() }} — <strong>GoPuff</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    color: '#109dce'
  })
}
</script>
